<template>
    <div>
        <div v-if="config_local" class="modal" @click.self="closeModal">
            <div class="configuration">
                <div class="informationPage">
                    <div class="flex-column">
                        <p>Accordion:</p>
                        <div>
                            <span>{{ config_local.accordionCode }}</span>
                            <AddAccordionModal :isActive="true" :onAccordionSave="saveAccordion" @blur="update" :accordionCode="config_local.accordionCode"></AddAccordionModal>
                        </div>
                        <div class="flexRow" style="padding-top: 10px;">
                            <label>
                                <input type="radio" value="Standard" v-model="config_local.accordionType" @blur="update" name="accordionType">
                                Standard Display
                            </label>
                            <label>
                                <input type="radio" value="SectionView" v-model="config_local.accordionType" @blur="update" name="accordionType">
                                Section View Display
                            </label>
                        </div>
                    </div>
                    <div class="flex-column">
                        <p>Section Title:</p>
                        <input type="text" v-model="sectionTitle" @blur="update('sectionTitleJson')"/>
                        <span style="position: relative">
                        <ToolTip v-if="languages && languages.length > 1" position="right" alignment="end" :includeWindowScroll="false">
                            <template #content>
                                <template v-for="lang in languages" :key="lang">
                                    <div v-if="lang !== 'English'">
                                        <h4>{{ lang }}:</h4>
                                        <p>{{ getTranslatedText(lang, config_local.sectionTitleJson) }}</p>
                                    </div>
                                </template>
                            </template>
                            <template #hoverIcon><i class="fa-solid fa-language"></i></template>
                        </ToolTip>
                        </span> 
                       </div>
                    <div class="flex-row">
                        <div class="flex-column"> 
                            <p>Section Title Color:</p>
                            <input type="text" v-model="config_local.sectionTitleColor"  @blur="update" />
                        </div>
                        <div class="colorSampleContainer">
                            <div class="colorSample" :style="colorSample(config_local.sectionTitleColor)"></div>
                        </div>
                    </div>
                    <div class="flexBreak"></div>
                    <div class="flex-row">
                        <div class="flex-column">
                            <p>Accordion Header Background Color:</p>
                            <input type="text" v-model="config_local.accordionHeaderBackground" @blur="update" />
                        </div>
                        <div class="colorSampleContainer">
                            <div class="colorSample" :style="colorSample(config_local.accordionHeaderBackground)"></div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-column">
                            <p>Accordion Header Background Color (Hover):</p>
                            <input type="text" v-model="config_local.accordionHeaderBackgroundHover" @blur="update" />
                        </div>
                        <div class="colorSampleContainer">
                            <div class="colorSample" :style="colorSample(config_local.accordionHeaderBackgroundHover)"></div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-column">
                            <p>Accordion Header Background Color (Active):</p>
                            <input type="text" v-model="config_local.accordionHeaderBackgroundActive" @blur="update" />
                        </div>
                        <div class="colorSampleContainer">
                            <div class="colorSample" :style="colorSample(config_local.accordionHeaderBackgroundActive)"></div>
                        </div>
                    </div>
                    <div class="flexBreak"></div>
                    <div class="flex-row">
                        <div class="flex-column">
                            <p>Accordion Header Icon:</p>
                            <input type="text" placeholder="Default: '/images/circle-plus.svg'" v-model="config_local.accordionHeaderIcon" @blur="update" />
                        </div>
                        <div class="colorSampleContainer">
                            <img class="iconSample" :src="config_local.accordionHeaderIcon ? config_local.accordionHeaderIcon : '/images/circle-plus.svg'" />
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-column">
                            <p>Accordion Header Icon (Hover):</p>
                            <input type="text" placeholder="Default: '/images/circle-plus.svg'" v-model="config_local.accordionHeaderIconHover" @blur="update" />
                        </div>
                        <div class="colorSampleContainer">
                            <img class="iconSample" :src="config_local.accordionHeaderIconHover ? config_local.accordionHeaderIconHover : '/images/circle-plus.svg'" />
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-column">
                            <p>Accordion Header Icon (Active):</p>
                            <input type="text" placeholder="Default: '/images/circle-minus.svg'" v-model="config_local.accordionHeaderIconActive" @blur="update" />
                        </div>
                        <div class="colorSampleContainer">
                            <img class="iconSample" :src="config_local.accordionHeaderIconActive ? config_local.accordionHeaderIconActive : '/images/circle-minus.svg'" />
                        </div>
                    </div>
                    <div class="flexBreak"></div>
                    <div class="flex-row">
                        <div class="flex-column">
                            <p>Accordion Header Text Color:</p>
                            <input type="text" placeholder="Default: '#FFFFFF'" v-model="config_local.accordionHeaderTextColor" @blur="update" />
                        </div>
                        <div class="colorSampleContainer">
                            <div class="colorSample" :style="colorSample(config_local.accordionHeaderTextColor, '#FFFFFF')"></div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-column">
                            <p>Accordion Header Text Color (Hover):</p>
                            <input type="text" placeholder="Default: '#FFFFFF'" v-model="config_local.accordionHeaderTextColorHover" @blur="update" />
                        </div>
                        <div class="colorSampleContainer">
                            <div class="colorSample" :style="colorSample(config_local.accordionHeaderTextColorHover, '#FFFFFF')"></div>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="flex-column">
                            <p>Accordion Header Text Color (Active):</p>
                            <input type="text" placeholder="Default: '#FFFFFF'" v-model="config_local.accordionHeaderTextColorActive" @blur="update" />
                        </div>
                        <div class="colorSampleContainer">
                            <div class="colorSample" :style="colorSample(config_local.accordionHeaderTextColorActive, '#FFFFFF')"></div>
                        </div>
                    </div>
                    <div class="flexBreak"></div>
                    <div class="flex-column">
                        <p>Accordion Header Sample:</p>
                        <div class="headerSample" :style="colorSample(config_local.accordionHeaderBackground, '#FFFFFF')">
                            <img class="iconSample" :src="config_local.accordionHeaderIcon ? config_local.accordionHeaderIcon : '/images/circle-plus.svg'" />
                            <span :style="{'color': config_local.accordionHeaderTextColor ? config_local.accordionHeaderTextColor : '#FFFFFF'}">Header Text</span>
                        </div>
                    </div>
                    <div class="flex-column">
                        <p>Accordion Header Sample (Hover):</p>
                        <div class="headerSample" :style="colorSample(config_local.accordionHeaderBackgroundHover, '#FFFFFF')">
                            <img class="iconSample" :src="config_local.accordionHeaderIconHover ? config_local.accordionHeaderIconHover : '/images/circle-plus.svg'" />
                            <span :style="{'color': config_local.accordionHeaderTextColorHover ? config_local.accordionHeaderTextColorHover : '#FFFFFF'}">Header Text</span>
                        </div>
                    </div>
                    <div class="flex-column">
                        <p>Accordion Header Sample (Active):</p>
                        <div class="headerSample" :style="colorSample(config_local.accordionHeaderBackgroundActive, '#FFFFFF')">
                            <img class="iconSample" :src="config_local.accordionHeaderIconActive ? config_local.accordionHeaderIconActive : '/images/circle-minus.svg'" />
                            <span :style="{'color': config_local.accordionHeaderTextColorActive ? config_local.accordionHeaderTextColorActive : '#FFFFFF'}">Header Text</span>
                        </div>
                    </div>
                </div>
                <button v-if="duplicationArray" type="button" class="duplicateButton" @click="openDuplicationModal">Duplicate Existing Configuration</button>
                <button type="button" class="closeButton" @click="closeModal">Close</button>
                <div v-if="duplicationModalActive" class="modal" @click.self="closeDuplicationModal">
                    <div class="duplicationModal">
                        <select v-model="selectedConfig">
                            <option v-for="(config, index) in otherConfigurations" :key="index" :value="config">{{ config.accordionCode }}</option>
                        </select>
                        <div class="duplicationPreview">
                            <div>Accordion Code: <span>{{ selectedConfig.accordionCode }}</span></div>
                            <div>Section Title: <span>{{ selectedConfig.sectionTitleJson }}</span></div>
                            <div>Section Title Color: <span>{{ selectedConfig.sectionTitleColor }}</span></div>
                            <div>Accordion Header Background Color: <span>{{ selectedConfig.accordionHeaderBackground }}</span></div>
                            <div>Accordion Header Icon: <span>{{ selectedConfig.accordionHeaderIcon }}</span></div>
                            <div>Accordion Header Text Color: <span>{{ selectedConfig.accordionHeaderTextColor }}</span></div>
                            <div>Accordion Header Background Color (Hover): <span>{{ selectedConfig.accordionHeaderBackgroundHover }}</span></div>
                            <div>Accordion Header Icon (Hover): <span>{{ selectedConfig.accordionHeaderIconHover }}</span></div>
                            <div>Accordion Header Text Color (Hover): <span>{{ selectedConfig.accordionHeaderTextColorHover }}</span></div>
                            <div>Accordion Header Background Color (Active): <span>{{ selectedConfig.accordionHeaderBackgroundActive }}</span></div>
                            <div>Accordion Header Icon (Active): <span>{{ selectedConfig.accordionHeaderIconActive }}</span></div>
                            <div>Accordion Header Text Color (Active): <span>{{ selectedConfig.accordionHeaderTextColorActive }}</span></div>
                        </div>
                        <div class="flex-break"></div>
                        <button type="button" class="closeButton" @click="closeDuplicationModal">Cancel</button>
                        <button type="button" class="duplicateButton" @click="duplicateConfiguration">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AddAccordionModal from '@/components/accordion/AddAccordionModal.vue';
import ToolTip from '@/components/shared/ToolTip2.vue';
import {translation} from '../../shared/translation';

export default {
    name: 'AccordionConfiguration',
    components: { AddAccordionModal, ToolTip },
    props: {
        configuration: {
            type: Object,
            required: true
        },
        parentObject: Object,
        onFieldUpdate: {
            type: Function
        },
        title: {
            type: String,
            default: 'Information Page Configuration'
        },
        onModalClose: Function,
        duplicationArray: {
            type: Array,
            default: null
        },
        languages: {
            type: Array,
            required: true
        },
        defaultLanguage: {
            type: String,
            default: () => 'English'
        }
    },
    data() {
        return {
            config_local: null,
            showConfiguration: false,
            duplicationModalActive: false,
            selectedConfig: {}
        }
    },
    computed: {
        otherConfigurations: function() {
            return this.duplicationArray.filter(config => JSON.stringify(config) !== JSON.stringify(this.configuration));
        },
        sectionTitle: {
            get() {
                return translation.getTextForLanguage(this.config_local.sectionTitleJson, this.defaultLanguage);
            },
            set(newText) {
                translation.setTextForLanguage(this.config_local, this.defaultLanguage, 'sectionTitleJson', newText);
            }
        },
    },
    mounted() {
        if(!this.configuration)
            this.config_local = {
                accordionCode: '',
                sectionTitleJson: [],
                accordionType: 'Standard',
                sectionTitleColor: '',
                accordionHeaderIcon: '',
                accordionHeaderTextColor: '',
                accordionHeaderBackground: '',
                accordionHeaderTextColorHover: '',
                accordionHeaderBackgroundHover: '',
                accordionHeaderTextColorActive: '',
                accordionHeaderBackgroundActive: '',
                isDefault: false
            }
        else
            this.config_local = {
                accordionCode: this.configuration.accordionCode ?? '',
                accordionType: this.configuration.accordionType ?? 'Standard',
                sectionTitleJson: this.configuration.sectionTitleJson ?? [],
                sectionTitleColor: this.configuration.sectionTitleColor ?? '',
                accordionHeaderIcon: this.configuration.accordionHeaderIcon ?? '',
                accordionHeaderTextColor: this.configuration.accordionHeaderTextColor ?? '',
                accordionHeaderBackground: this.configuration.accordionHeaderBackground ?? '',
                accordionHeaderTextColorHover: this.configuration.accordionHeaderTextColorHover ?? '',
                accordionHeaderBackgroundHover: this.configuration.accordionHeaderBackgroundHover ?? '',
                accordionHeaderTextColorActive: this.configuration.accordionHeaderTextColorActive ?? '',
                accordionHeaderBackgroundActive: this.configuration.accordionHeaderBackgroundActive ?? '',
                isDefault: this.configuration.isDefault ?? false
            }
    },
    methods: {
        colorSample: function(color, defaultColor) {
            if(color) {
                return {
                    'background': color,
                    'background-color': color
                }
            } else if(defaultColor) {
                return {
                    'background': defaultColor,
                    'background-color': defaultColor
                }
            } else {
                return '';
            }
        },
        update: async function(fieldName) {
            if(fieldName === 'sectionTitleJson') 
                this.config_local.sectionTitleJson = 
                    await translation.addTranslations(this.config_local.sectionTitleJson, 
                        this.sectionTitle, this.languages, this.defaultLanguage);

            if(this.onFieldUpdate)
                await this.onFieldUpdate(this.config_local, this.parentObject);
        },
        toggleConfiguration: function() {
            this.showConfiguration = !this.showConfiguration;
        },
        saveAccordion: async function(accordionCode) {
            this.config_local.accordionCode = accordionCode;
            await this.update();
        },
        closeModal: function() {
            if(this.onModalClose)
                this.onModalClose();
        },
        openDuplicationModal: function() {
            this.duplicationModalActive = true;
        },
        closeDuplicationModal: function() {
            this.duplicationModalActive = false;
        },
        duplicateConfiguration: function() {
            this.config_local = structuredClone(this.selectedConfig);
            this.closeDuplicationModal();
            this.update();
        },
        getTranslatedText: function(language, json) {
            return translation.getTranslatedText(language, json);
        }
    }
}
</script>

<style scoped>
    .modal {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0px;
        left: 0px;
        backdrop-filter: blur(4px);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }
    .configuration {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background: white;
        width: 80%;
        padding: 20px;
        border-radius: 20px;
        border: 1px gray solid;
    }
    .configurationTitle {
        cursor: pointer;
    }
    .configurationTitle span {
        margin-right: 10px;
        font-size: 24px;
    }
    .iconSample {
        margin: auto;

    }
    .headerSample {
        padding: 10px;
        display: flex;
        align-items: center;
        border-radius: 5px;
    }
    .headerSample span {
        margin-left: 50px;
    }  
    .informationPage {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 40px;
    } 
    .informationPage > div:not(.flexBreak) {
        flex: 1 1 200px;
        border: solid 1px gray;
        padding: 10px;
        display: flex; 
        border-radius: 10px;
        margin: 5px;
        background: lightgray;
    }
    .informationPage  div.flex-column  {
        display: flex;
        flex-direction: column;  
    }
    .informationPage  div.flex-row  {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    div > input[type='text'] {
        width: 200px;
    }
    .closeButton {
        padding: 10px;
        border-radius: 10px;
        background: lightgray;
        position:absolute;
        left: 25px;
        bottom: 10px;
        cursor: pointer;
        border: solid 1px gray;
    }
    .duplicateButton {
        padding: 10px;
        border-radius: 10px;
        background: #036991;
        position:absolute;
        right: 25px;
        bottom: 10px;
        cursor: pointer;
        border: solid 1px gray;
        color: white;
    }
    .colorSampleContainer {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .duplicationModal {
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        background: white;
        width: 700px;
        padding: 20px;
        border-radius: 20px;
        border: 1px gray solid;
    }
    .duplicationModal select {
        height: 30px;
    }
    .duplicationPreview {
        width: 60%;
        margin: 0 0 40px 20px;
    }
    .duplicationPreview div {
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
    }
</style>